import React, { useState, useEffect } from "react";
import { useUser } from "../UserContext"; // Assure-toi que ce hook est correctement défini et exporté
import {
  FaEnvelope,
  FaSun,
  FaMoon,
  FaSignOutAlt,
  FaSignInAlt,
  FaUserPlus,
  FaBell,
  FaCog,
} from "react-icons/fa";
import { MdOutlineMessage } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useMessage } from "./../../../hooks/MessageContext";
import { useContactForm } from "./../../../hooks/ContactFormContext";
import { Divide as Hamburger } from "hamburger-react";
import { checkRoleAccess } from "../../../utils/roleHelper";

const Navbar3 = () => {
  const { user, updateUser } = useUser();
  const [menuOpen, setMenuOpen] = useState(false);
  const { unreadMessageCount } = useMessage();
  const { unreadCountContactForm } = useContactForm();
  const navigate = useNavigate();

  useEffect(() => {}, [user]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const renderLink = (label, path, roleRequired) => {
    if (!user || !user.role_id) {
      console.error("Utilisateur ou role_id manquant :", user);
      return null; // Retourne null si l'utilisateur ou son rôle n'est pas défini
    }

    const hasAccess = checkRoleAccess(user.role_id, roleRequired);

    return (
      <li
        className={`${
          hasAccess
            ? "hover:underline cursor-pointer text-white"
            : "text-gray-400 cursor-not-allowed"
        }`}
        onClick={() => hasAccess && handleNavigation(path)}
      >
        {label}
      </li>
    );
  };

  useEffect(() => {
    // Tente de lire les informations de l'utilisateur depuis localStorage
    const storedUserInfo = localStorage.getItem("userInfo");
    if (storedUserInfo) {
      try {
        const userInfo = JSON.parse(storedUserInfo);
        if (userInfo && !user) {
          updateUser(userInfo); // Met à jour l'état global de l'utilisateur si pas déjà défini
        }
      } catch (error) {
        console.error(
          "Erreur lors du parsing des informations de l'utilisateur",
          error
        );
      }
    }
  }, [user, updateUser]);

  const handleLogout = () => {
    localStorage.removeItem("userInfo");
    localStorage.removeItem("token");
    updateUser(null); // Réinitialise l'utilisateur
    navigate("/login"); // Redirection vers la page de connexion
  };

  const toggleTheme = () => {
    const theme = document.documentElement.classList.toggle("dark")
      ? "dark"
      : "light";
    localStorage.setItem("theme", theme);
  };

  const handleNavigation = (path, roleRequired = []) => {
    // Si aucune restriction de rôle, tout le monde peut accéder
    if (roleRequired.length === 0 || path === "/formules-tarifs") {
      navigate(path);
      setMenuOpen(false);
      return;
    }

    if (!user || !user.role_id) {
      console.error("Utilisateur ou role_id manquant :", user);
      return;
    }

    const hasAccess = checkRoleAccess(user.role_id, roleRequired);

    if (hasAccess) {
      navigate(path);
      setMenuOpen(false);
    }
  };

  return (
    <>
      {/* Barre de navigation principale */}
      <nav className="fixed z-30 w-full bg-neutral-800 text-white flex items-center justify-between h-[80px] md:h-[100px] shadow-lg">
        {/* Partie gauche : Menu Hamburger */}
        <div
          className="flex flex-col items-center justify-center w-[80px] h-[80px] md:w-[100px] md:h-[100px] bg-blueprimary hover:bg-blueprimarylight cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)} // Déplacez onClick ici
        >
          <Hamburger
            toggled={menuOpen}
            toggle={setMenuOpen}
            size={32} // Taille de l'icône
            direction="right" // Direction des lignes lors de l'ouverture
            duration={0.5} // Durée de la transition
            color="white" // Couleur des lignes
          />
          <span className="text-white text-sm font-semibold md:text-base md:mt-2 ">
            {menuOpen ? "FERMER" : "MENU"}
          </span>
        </div>

        {/* Logo et Titre */}
        <div className="flex items-center space-x-2 md:space-x-4">
          <img
            src="/logo_presence-pro3.png"
            alt="Présence Club Pro Logo"
            className="h-[60px] md:h-[90px] w-auto cursor-pointer object-cover"
            onClick={() => handleNavigation("/")}
          />
          {/* Titre masqué en mode mobile */}
          <h1 className="hidden md:block text-xl md:text-3xl font-bold tracking-wide truncate text-satoshi">
            Présence Club Pro
          </h1>
        </div>

        {/* Icônes d'action */}
        <div className="flex items-center space-x-4">
          {/* Messages */}
          {user && (
            <>
              {/* Icône pour les messages personnels */}
              <div
                className="relative cursor-pointer"
                onClick={() => handleNavigation("/messagerie-judoka")}
              >
                <FaEnvelope
                  className="text-white text-lg"
                  title="Vos Messages"
                />
                {unreadMessageCount > 0 && (
                  <span className="absolute -top-3 -right-3 bg-red-600 text-white text-xs rounded-full px-2 py-0.5">
                    {unreadMessageCount}
                  </span>
                )}
              </div>

              {/* Icône pour les messages de ContactForm */}
              {user?.role_id === 1 && (
                <div
                  className="relative cursor-pointer"
                  onClick={() => handleNavigation("/appli/dashboard")}
                >
                  <MdOutlineMessage
                    className="text-white text-lg"
                    title="Messages du Formulaire"
                  />
                  {unreadCountContactForm > 0 && (
                    <span className="absolute -top-3 -right-3 bg-red-600 text-white text-xs rounded-full px-2 py-0.5">
                      {unreadCountContactForm}
                    </span>
                  )}
                </div>
              )}

              {user?.role_id === 1 && (
                <div
                  className="relative cursor-pointer"
                  onClick={() => handleNavigation("/appli/dashboard")}
                >
                  <FaCog
                    className="text-white text-lg"
                    title="Tableau de bord Administratif"
                  />
                </div>
              )}
            </>
          )}

          {/* Avatar (uniquement si connecté) */}
          {user && user.userId > 0 && (
            <div
              className="flex items-center cursor-pointer"
              onClick={() => handleNavigation("/profile-utilisateur")}
            >
              <img
                src={`${
                  user.photoURL || "/img/user_avatar.jpg"
                }?v=${new Date().getTime()}`} // Ajout de ?v pour contourner le cache
                alt="Avatar Utilisateur"
                className="w-10 h-10 rounded-full cursor-pointer object-cover"
                title="Profil Utilisateur"
              />
            </div>
          )}

          {/* Déconnexion (uniquement si connecté) */}
          {user?.userId && (
            <FaSignOutAlt
              className="text-white text-lg cursor-pointer"
              onClick={handleLogout}
              title="Déconnexion"
            />
          )}

          {/* Inscription (si non connecté) */}
          {!user && (
            <div
              className="flex items-center justify-center w-10 h-10 rounded-full bg-blueprimary text-white hover:bg-blueprimarylight cursor-pointer transition-all"
              onClick={() => navigate("/register")}
              title="Créer un compte"
            >
              <FaUserPlus className="text-lg" />
            </div>
          )}

          {/* Connexion (si non connecté) */}
          {!user && (
            <div
              className="flex items-center justify-center w-10 h-10 rounded-full bg-blueprimary text-white hover:bg-blueprimarylight cursor-pointer transition-all"
              onClick={() => navigate("/login")}
              title="Connexion"
            >
              <FaSignInAlt className="text-lg" />
            </div>
          )}

          {/* Dark/Light Mode Toggle */}
          <label className="swap swap-rotate cursor-pointer pr-4">
            <input type="checkbox" onChange={toggleTheme} />
            <FaSun className="swap-off text-white w-5 h-5" />
            <FaMoon className="swap-on text-white w-5 h-5" />
          </label>
        </div>
      </nav>

      {/* Menu déroulant */}
      {menuOpen && (
        <div
          className={`fixed top-[100px] left-0 w-full bg-gray-900 bg-opacity-90 text-white py-10 z-20 transition-all duration-600 overflow-y-auto max-h-[calc(100vh-100px)]`}
          style={{ maxHeight: "calc(100vh - 100px)" }} // Limite la hauteur à la vue disponible
        >
          <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 px-6">
            {/* Section 1 */}
            <div>
              <h3 className="text-lg md:text-lg mb-4 border-b-2 border-blueprimary pb-1">
                <span className="bg-blueprimary p-2 font-semibold">COMPTE</span>
              </h3>
              <ul className="space-y-2 text-base md:text-base">
                {/* Profil Utilisateur */}
                <li
                  className={`${
                    checkRoleAccess(user?.role_id, [1, 2, 3, 4, 5, 6, 7])
                      ? "hover:underline cursor-pointer text-white"
                      : "text-gray-400 cursor-not-allowed"
                  }`}
                  onClick={() =>
                    handleNavigation("/profile-utilisateur", [1, 2, 3, 4, 5, 6, 7])
                  }
                >
                  Profil Utilisateur
                </li>

                {/* Messages */}
                <li
                  className={`${
                    checkRoleAccess(user?.role_id, [1, 2, 3, 4, 5, 6, 7])
                      ? "hover:underline cursor-pointer text-white"
                      : "text-gray-400 cursor-not-allowed"
                  } flex items-center space-x-2`}
                  onClick={() =>
                    handleNavigation("/messagerie-judoka", [1, 2, 3, 4, 5, 6, 7])
                  }
                >
                  <div className="relative">
                    <FaEnvelope
                      className="text-white text-lg"
                      title="Vos Messages"
                    />
                    {unreadMessageCount > 0 && (
                      <span className="absolute -top-2 -right-3 bg-red-600 text-white text-xs rounded-full px-2 py-0.5">
                        {unreadMessageCount}
                      </span>
                    )}
                  </div>
                  <span className="ml-4">Messages</span>
                </li>

                {/* Formules & Tarifs */}
                <li
                  className="hover:underline cursor-pointer text-white"
                  onClick={() => handleNavigation("/formules-tarifs", [])}
                >
                  Formules & Tarifs
                </li>

                {/* Mon Abonnement */}
                <li
                  className={`${
                    checkRoleAccess(user?.role_id, [1, 2, 3, 4, 5, 7])
                      ? "hover:underline cursor-pointer text-white"
                      : "text-gray-400 cursor-not-allowed"
                  }`}
                  onClick={() => {
                    if (checkRoleAccess(user?.role_id, [1, 2, 3, 4, 5, 7])) {
                      handleNavigation("/mon-abonnement");
                    }
                  }}
                >
                  Mon Abonnement
                </li>
              </ul>
            </div>

            {/* Section 2 */}
            <div>
              <h3 className="text-lg md:text-lg mb-4 border-b-2 border-green-600 pb-1">
                <span className="bg-green-600 p-2 font-semibold">
                  DIRIGEANT
                </span>
              </h3>
              <ul className="space-y-2 text-base md:text-base">
                {/* Gestion du Club */}
                <li
                  className={`${
                    checkRoleAccess(user?.role_id, [1, 2, 3, 4, 5, 7])
                      ? "hover:underline cursor-pointer text-white"
                      : "text-gray-400 cursor-not-allowed"
                  }`}
                  onClick={() => {
                    if (checkRoleAccess(user?.role_id, [1, 2, 3, 4, 5, 7])) {
                      handleNavigation("/votre-club");
                    }
                  }}
                >
                  Votre Club
                </li>

                {/* Gestion des Dojo & Groupes */}
                <li
                  className={`${
                    checkRoleAccess(user?.role_id, [1, 2, 3, 4, 5, 7])
                      ? "hover:underline cursor-pointer text-white"
                      : "text-gray-400 cursor-not-allowed"
                  }`}
                  onClick={() => {
                    if (checkRoleAccess(user?.role_id, [1, 2, 3, 4, 5, 7])) {
                      handleNavigation("/dojo-groupe");
                    }
                  }}
                >
                  Lieux & Groupes
                </li>

                {/* Gestion des Membres */}
                <li
                  className={`${
                    checkRoleAccess(user?.role_id, [1, 2, 3, 4, 5, 7])
                      ? "hover:underline cursor-pointer text-white"
                      : "text-gray-400 cursor-not-allowed"
                  }`}
                  onClick={() => {
                    if (checkRoleAccess(user?.role_id, [1, 2, 3, 4, 5, 7])) {
                      handleNavigation("/gestion-membres");
                    }
                  }}
                >
                  Gestion des Adhérents
                </li>

                {/* Gestion des enseignants */}
                <li
                  className={`${
                    checkRoleAccess(user?.role_id, [1, 2, 3, 4, 5, 7])
                      ? "hover:underline cursor-pointer text-white"
                      : "text-gray-400 cursor-not-allowed"
                  }`}
                  onClick={() => {
                    if (checkRoleAccess(user?.role_id, [1, 2, 3, 4, 5, 7])) {
                      handleNavigation("/gestion-enseignants");
                    }
                  }}
                >
                  Gestion des enseignants
                </li>
              </ul>
            </div>

            {/* Section 3 */}
            <div>
              <h3 className="text-lg md:text-lg mb-4 border-b-2 border-orange-600 pb-1">
                <span className="bg-orange-600 p-2 font-semibold">
                  PRÉSENCES
                </span>
              </h3>
              <ul className="space-y-2 text-base md:text-base">
                {/* Gestion des Présences */}
                <li
                  className={`${
                    checkRoleAccess(user?.role_id, [1, 2, 3, 4, 5, 6, 7])
                      ? "hover:underline cursor-pointer text-white"
                      : "text-gray-400 cursor-not-allowed"
                  }`}
                  onClick={() =>
                    handleNavigation("/gestion-presences", [1, 2, 3, 4, 5, 6, 7])
                  }
                >
                  Gestion des Présences
                </li>

                {/* Affichage des Présences */}
                <li
                  className={`${
                    checkRoleAccess(user?.role_id, [1, 2, 3, 4, 5, 6, 7])
                      ? "hover:underline cursor-pointer text-white"
                      : "text-gray-400 cursor-not-allowed"
                  }`}
                  onClick={() =>
                    handleNavigation("/affichage-presences", [1, 2, 3, 4, 5, 6, 7])
                  }
                >
                  Tableaux de Présences
                </li>

                {/* Statistiques */}
                <li
                  className={`${
                    checkRoleAccess(user?.role_id, [1, 2, 3, 4, 5, 6, 7])
                      ? "hover:underline cursor-pointer text-white"
                      : "text-gray-400 cursor-not-allowed"
                  }`}
                  onClick={() =>
                    handleNavigation(
                      "/statistiques-presences",
                      [1, 2, 3, 4, 5, 6, 7]
                    )
                  }
                >
                  Statistiques
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar3;
